module.exports = __webpack_public_path__ + "img/ic_classground.c6404581.svg";